module.exports = __webpack_public_path__ + "static/img/11.9cda93f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/1/3/eng/11.png
// module id = hWVz
// module chunks = 0